module.exports = __webpack_public_path__ + "img/game5.9facd888.png";